import { Box, IconNewWindow, Text } from 'braid-design-system';

import { TextLink, type TextLinkProps } from 'src/components/Link/Link';

export const ExternalLink = (
  textlinkProps: Omit<TextLinkProps, 'children'>,
) => (
  <Box marginTop="xxsmall">
    <Text>
      <TextLink {...textlinkProps} target="_blank">
        <IconNewWindow alignY="lowercase" />
      </TextLink>
    </Text>
  </Box>
);
